export default {
	data() {
		return { defaultColumnDefinition: { resizable: false, } };
	},
	computed: {
		columnDefinitions() {
			return [
				{
					field: 'name',
					displayName: this.$t('name'),
					minWidth: 300,
					resizable: true,
				},
				{
					field: 'street',
					displayName: this.$t('street'),
					minWidth: 180,
					resizable: true,
				},
				{
					field: 'postalPlace',
					displayName: this.$t('postalPlace'),
					minWidth: 80,
					resizable: true,
				},
				{
					field: 'postalCode',
					displayName: this.$t('postalCode'),
					width: 60,
					resizable: true,
				},
				{
					field: 'countryCode',
					displayName: this.$t('countryCode'),
					width: 70,
					resizable: true,
				},
				{
					field: 'contactPhone',
					displayName: this.$t('phone'),
					width: 80,
				},
				{
					field: 'contactEmail',
					displayName: this.$t('email'),
					width: 200,
				},
				{
					field: 'marks',
					displayName: this.$t('marks'),
					width: 150,
				}
			];
		}
	}
};